import { Filters, ChoiceList } from '@shopify/polaris'
import { isEmpty } from 'lodash'

const DashboardFilter = ({ search, status, setSearch, setStatus }) => {

  const handleStatusChange = (value) => setStatus(value)
  const handleStatusRemove = () => setStatus(null)

  const filters = [
    {
      key: 'status',
      label: 'Status',
      filter: (
        <ChoiceList
          title="Status"
          titleHidden
          choices={[
            { label: 'Running', value: 'running' },
            { label: 'Paused', value: 'paused' },
            { label: 'Pending', value: 'pending' },
            { label: 'Winner assigned', value: 'winner_assigned' },
            { label: 'Completed', value: 'completed' },
          ]}
          selected={status || []}
          onChange={handleStatusChange}
          allowMultiple
        />
      ),
      shortcut: true,
    },
  ]

  function disambiguateLabel(key, value) {
    switch (key) {
      case 'status':
        return value.map((val) => `Status ${val}`).join(', ')
      default:
        return value
    }
  }

  const appliedFilters = []
  if (!isEmpty(status)) {
    const key = 'status'
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, status),
      onRemove: handleStatusRemove,
    })
  }

  return (
    <Filters
      queryValue={search}
      filters={filters}
      appliedFilters={appliedFilters}
      onQueryChange={setSearch}
      onQueryClear={setSearch}
    />
  )
}

export default DashboardFilter
